import request from '../utils/request.js'

export default {
	//获取验证码
	captcha(params) {
		
		return request.post(`index/captcha`, params).then(res => res.data);
	},
	//登录
	login(params) {
		return request.post(`user/login`, params).then(res => res.data);
	},
}


// WEBPACK FOOTER //
// ./src/api/login.js